export const workNotes = {
  addWorkNote: "Add work note",
  workNote: "Work note",
  validationRequired: "It is required to enter a work note before saving"
};
